import { mergeMap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService } from ".";
import * as _ from 'lodash';
import { of } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {

    constructor(private userService:UserService) {}

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return this.userService.isLoggedIn().pipe(mergeMap(status => of(status.user && _.find(status.user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false)));
    }
}